import { CheckmarkIcon } from "./icons";

export default function CopyNotification() {
  return (
    <div className="flex items-center gap-2.5 rounded-[5px] bg-white py-2.5 pr-3 pl-4 shadow-0-0-10 shadow-deep-koamaru/20">
      <CheckmarkIcon />
      <p className="font-medium text-14/[1.2em] text-black">Link copied</p>
    </div>
  );
}
